<mat-form-field appearance="outline" floatLabel="always" color="white" [ngClass]="inputClass">
  <mat-label><ng-content></ng-content></mat-label>

  <input
    autocomplete="off"
    matInput
    appNumericInput
    [appAutoFocus]="autofocus"
    [minValue]="minValue"
    [maxValue]="maxValue"
    [decimals]="decimals"
    [allowNegative]="allowNegative"
    [allowFractional]="allowFractional"
    [keepLastValid]="keepLastValid"
    [name]="name"
    [placeholder]="placeholder"
    [formControl]="control"
    [required]="required"
    [readonly]="!!readonly"
    (blur)="blur.emit($event)"
    (keydown.enter)="enterPressed.emit($event)"
  />

  @if (suffix) {
    <span matSuffix>{{ suffix }}</span>
  }

  <mat-error>{{ errorMessage }}</mat-error>
</mat-form-field>
